import { Outlet, Link } from 'react-router-dom';
import { B2bProvider, useB2b } from '../context/B2bContext';
import { Building2, LogOut } from 'lucide-react';

const B2bHeader = () => {
  const { customer, logout } = useB2b();
  return (
    <header className="sticky top-0 z-50" style={{ background: 'linear-gradient(to right, #07163d, #0d3089)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <Link to="/empresas" className="flex items-center gap-2 text-white" data-testid="b2b-logo">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/api/settings/shop-config/image/categories/logo_white.png`}
              alt="Supertech"
              className="h-7 sm:h-9 w-auto object-contain"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <span className="hidden sm:inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider bg-amber-400 text-slate-900 px-2.5 py-1 rounded-full">
              <Building2 className="w-3.5 h-3.5" /> Portal Empresas
            </span>
          </Link>
          <div className="flex items-center gap-3">
            {customer && (
              <>
                <span className="hidden sm:block text-sm text-blue-100 font-medium" data-testid="b2b-company-name">
                  {customer.company_name}
                </span>
                <button
                  onClick={logout}
                  className="inline-flex items-center gap-2 text-sm text-white/90 hover:text-white bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg transition-colors"
                  data-testid="b2b-logout-btn"
                >
                  <LogOut className="w-4 h-4" /> Salir
                </button>
              </>
            )}
            <Link to="/" className="text-xs text-blue-200 hover:text-white transition-colors">
              Tienda
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default function B2bLayout() {
  return (
    <B2bProvider>
      <div className="min-h-screen bg-slate-50">
        <B2bHeader />
        <main>
          <Outlet />
        </main>
      </div>
    </B2bProvider>
  );
}
